class Link {
    url = "";
    label = "";
    color = ""; //[green, orange]
    direction = ""; //[left, center, right]

    constructor(url, label, color, direction) {
        this.url = url;
        this.label = label;
        if (color !== undefined) {
            this.color = color;
        } else {
            this.color = 'green';
        }
        if (direction !== undefined) {
            this.direction = direction;
        } else {
            this.direction = 'left';
        }
    }
}

export default Link;